import Vue from 'vue'
import Router from 'vue-router'
import { getToken } from '../utils/auth'

import AdminLayout from '../layout/AdminLayout.vue'
import LoginView from '../views/Login.vue'
import UserListView from '../views/users/UserList.vue'
import UserPublicationsView from '../views/users/UserPublications.vue'
import ProductListView from '../views/products/ProductList.vue'
import QualificationListView from '../views/qualifications/QualificationList.vue'
import BannerListView from '../views/banners/BannerList.vue'
import DisplayImageListView from '../views/display/DisplayImageList.vue'
import VarietyListView from '../views/varieties/VarietyList.vue'
import RegionListView from '../views/regions/RegionList.vue'
import CustomerServiceQrListView from '../views/customer-service-qrs/CustomerServiceQrList.vue'
import GlobalControlView from '../views/global-controls/GlobalControl.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginView,
      meta: { public: true }
    },
    {
      path: '/',
      component: AdminLayout,
      redirect: '/users',
      children: [
        {
          path: '/users',
          name: 'users',
          component: UserListView,
          meta: { title: '用户管理' }
        },
        {
          path: '/users/:openid/publications',
          name: 'user-publications',
          component: UserPublicationsView,
          meta: { title: '用户发布管理' }
        },
        {
          path: '/products',
          name: 'products',
          component: ProductListView,
          meta: { title: '销售管理', productType: 'SALE' }
        },
        {
          path: '/purchases',
          name: 'purchases',
          component: ProductListView,
          meta: { title: '求购管理', productType: 'PURCHASE' }
        },
        {
          path: '/qualifications',
          name: 'qualifications',
          component: QualificationListView,
          meta: { title: '资质管理' }
        },
        {
          path: '/banners',
          name: 'banners',
          component: BannerListView,
          meta: { title: '轮播管理' }
        },
        {
          path: '/display',
          name: 'display',
          component: DisplayImageListView,
          meta: { title: '展示管理' }
        },
        {
          path: '/varieties',
          name: 'varieties',
          component: VarietyListView,
          meta: { title: '品种管理' }
        },
        {
          path: '/regions',
          name: 'regions',
          component: RegionListView,
          meta: { title: '地区管理' }
        },
        {
          path: '/customer-service-qrs',
          name: 'customer-service-qrs',
          component: CustomerServiceQrListView,
          meta: { title: '客服二维码管理' }
        },
        {
          path: '/global-controls',
          name: 'global-controls',
          component: GlobalControlView,
          meta: { title: '全量控制' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/users'
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.meta && to.meta.public) {
    if (token) {
      next('/users')
      return
    }
    next()
    return
  }
  if (!token) {
    next('/login')
    return
  }
  next()
})

export default router
